import cover1 from './gamecover/85193418-6704-4f40-9fee-26e363f7d9ac.jpg';
import cover2 from './gamecover/2b923433-7997-47fa-b6ee-b1915fcf811f.jpg';
import cover3 from './gamecover/e0e09c1a-9f54-436d-acf3-dce82cdb649f.png';
import cover4 from './gamecover/b83d27de-2935-4007-9989-a88348aadec8.jpeg';
import cover5 from './gamecover/524021b0-97ee-4d3b-8440-f3408b3eece0.png';
import cover6 from './gamecover/cf3ee0ca-02a1-439a-bede-68c8729ff9be.png';
import cover7 from './gamecover/da043825-5894-4097-87f5-8b978b79d1d9.jpg';
import cover8 from './gamecover/d3e30b44-8c5b-473d-8556-8c3eb4f72e1f.png';
import cover9 from './gamecover/c8517952-4ac9-4e0c-9c72-bc2c2522eb7a.jpg';
import cover10 from './gamecover/4bfd4d98-9863-4052-a22b-04472982b43a.png';
import cover11 from './gamecover/577add19-bd28-4cf0-b0f5-e883f3eb611a.jpg';
import cover12 from './gamecover/7ba98337-2ff1-4864-bd42-77106600dbdd.jpg';
import cover13 from './gamecover/92859965-fd43-4da4-9129-655fc1be5b28.jpg';
import cover14 from './gamecover/f0df3cb6-6060-4f67-aeb1-e2fc7fdbc859.jpg';
import cover15 from './gamecover/portrait.png';
import cover16 from './gamecover/199102c5-2f9b-4392-8704-1a04a61be963.jpg';
import cover17 from './gamecover/ee45b536-6492-49ce-98c2-36f9b48e9327.jpg';
import cover18 from './gamecover/ba7c138d-6c39-4eeb-8ad0-c46d089ed652.jpg';
import cover19 from './gamecover/8d4678ab-58c8-4275-910e-239d6b278a8e.jpg';
import cover20 from './gamecover/3a36511b-f91c-4789-9905-1cdbd19147c3.png';
import cover21 from './gamecover/11911435-5e4d-4914-b624-ffae26c7ed13.png';
import cover22 from './gamecover/502900fb-169b-4ede-886c-efacfa78a67b.jpg';
import cover23 from './gamecover/b2183f46-5c6b-4573-867a-fe8178a8cb5b.png';
import cover24 from './gamecover/d933c1d9-2415-41f5-823b-b86ca8a68ee1.jpg';
import cover25 from './gamecover/07e937f9-efe8-4fbb-b8c8-6e3bb3b4537e.png';
import cover26 from './gamecover/6f7abe26-e73c-461a-8cd8-fdcad3c9ab4a.png';
import cover27 from './gamecover/5cbadae7-7142-4736-ac71-fa8ae1545390.jpg';
import cover28 from './gamecover/f78628df-73ed-4524-9ba0-a9b312fbd8c6.png';
import cover29 from './gamecover/e79514f7-dfde-44b9-b780-573fa90019c0.png';
import cover30 from './gamecover/0458fedd-75f7-4aee-a0f1-8efb1fd455b4.jpg';
import cover31 from './gamecover/a5d8f5b9-8abf-4e5f-9304-befda49f812e.jpg';
import cover32 from './gamecover/0c30cba8-9b4b-413e-a35d-1f5bfeb58360.jpg';
import cover33 from './gamecover/9bded848-02b2-45c8-8e05-4261b905487a.jpg';
import cover34 from './gamecover/a876beb7-9742-4fe6-bffa-058278e65fad.jpg';
import cover35 from './gamecover/b1f6caf2-3ead-43c3-87ff-bfe7733665f8.jpg';

const brands = [
  cover1, cover2, cover3, cover4, cover5, cover6, cover7, cover8, cover9, cover10,
  cover11, cover12, cover13, cover14, cover15, cover16, cover17, cover18, cover19, cover20,
  cover21, cover22, cover23, cover24, cover25, cover26, cover27, cover28, cover29, cover30,
  cover31, cover32, cover33, cover34, cover35
];

export default brands;
